/**
 * Terminal value formatting.
 *
 * Results are formatted (and truncated) once at command completion so the
 * store never retains raw result values and renders never re-stringify.
 */

export const MAX_DISPLAY_CHARS = 24_000;

export function formatTerminalValue(value: unknown): string {
  try {
    const text = JSON.stringify(value, null, 2);
    if (typeof text !== "string") return String(value);
    if (text.length <= MAX_DISPLAY_CHARS) return text;
    return `${text.slice(0, MAX_DISPLAY_CHARS)}\n… (truncated ${text.length - MAX_DISPLAY_CHARS} chars)`;
  } catch {
    return String(value);
  }
}
